import React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import YearSection from "./YearSection";
import Cover from "./Cover";
import "../css/PortfolioView.css"
import Footer from "./Footer";

const PortfolioView = ({ artworks }) => {
    const navigate = useNavigate();
    
    const groupedByYear = React.useMemo(() => {
        const years = {};
        for (const art of artworks) {
            if (!years[art.year]) years[art.year] = [];
            years[art.year].push(art);
        }
        return Object.entries(years)
            .sort(([y1], [y2]) => Number(y2) - Number(y1)); // newest first
    }, [artworks]);

    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                el.scrollIntoView();
            }
        }
    }, [location.hash]);

    return (
        <>
            <Cover />
            <div className="portfolio-container">
                <>
                {groupedByYear.map(([year, yearArts]) => {
                    const featured = yearArts.filter(a => a.tags?.includes("featured"));
                    const projects = {};

                    for (const art of yearArts) {
                        const projectName = art.project?.trim();
                        if (!projects[projectName]) projects[projectName] = [];
                        projects[projectName].push(art);
                    }

                    return (
                        <YearSection
                            key={year}
                            year={year}
                            id={`year-${year}`}
                            featured={featured}
                            projects={projects}
                            onProjectClick={projectName => {
                                const name = projectName === "" ? "Obras Independientes" : projectName;
                                navigate(`/${year}/${name}`);
                            }}
                        />
                    );
                })}
                <Footer/>
                </>
            </div>
        </>
    );
};

export default PortfolioView;
